import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { downloadSecureFile } from "../../utils/secureFileDownload";
import { useAuth } from "../../context/AuthContext";

import Breadcrumbs from "../../components/breacrumbs";
import BackButton from "../../components/backButton";
/* import api from "../../services/api.js"; */

const DocumentsPage = () => {
  const { user } = useAuth();
  
  const handleCardClick = (url) => {
    // Detecta Safari (incluindo mobile)
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    
    if (isSafari || isIOS) {
      // Para Safari/iOS: tenta primeiro window.open, se falhar usa link
      try {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
          // Se window.open foi bloqueado, usa método do link
          const link = document.createElement('a');
          link.href = url;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          link.style.display = 'none';
          
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            document.body.removeChild(link);
          }, 100);
        }
      } catch (error) {
        // Fallback: usa método do link
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div>
      <div className="container d-flex align-items-center justify-content-between mt-3 mb-1">
        <BackButton toFallback="/home" />
        <Breadcrumbs />
      </div>
      <div className="documents-title-minimal">
        <h2>DOCUMENTOS</h2>
        <p className="documents-count">Acesso aos arquivos oficiais</p>
      </div>
      <section className="home-section1">
        <div
          className="container position-relative"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="row flex-column flex-lg-row justify-content-center">
            {/* Coluna principal */}
            <div className="col-lg-10">
              <div className="row g-3">
                <div className="col-xl-4 col-sm-6 col-12">
                  <div 
                    className="card document-card estatuto h-100" 
                    onClick={(e) => {
                      e.preventDefault();
                      // Força execução imediata para manter contexto de user gesture no Safari
                      setTimeout(() => downloadSecureFile('Estatuto.pdf', user), 0);
                    }}
                    role="button"
                    tabIndex={0}
                    aria-label="Baixar Estatuto - Documento oficial da Associação"
                    style={{ 
                      cursor: 'pointer',
                      WebkitTapHighlightColor: 'rgba(0,0,0,0)'
                    }}
                  >
                    <div className="card-content">
                      <div className="card-body">
                        <div className="media d-flex">
                          <div className="media-body text-left">
                            <h4 className="text-primary mb-1">Estatuto</h4>
                            <p className="card-subtitle">Documento oficial da Associação</p>
                          </div>
                          <div className="align-self-center">
                            <i className="bi bi-file-ruled text-primary"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-sm-6 col-12">
                  <div 
                    className="card document-card regimento h-100" 
                    onClick={(e) => {
                      e.preventDefault();
                      // Força execução imediata para manter contexto de user gesture no Safari
                      setTimeout(() => downloadSecureFile('Regimento_ASemDestino.pdf', user), 0);
                    }}
                    role="button"
                    tabIndex={0}
                    aria-label="Baixar Regimento Interno - Normas e procedimentos internos"
                    style={{ 
                      cursor: 'pointer',
                      WebkitTapHighlightColor: 'rgba(0,0,0,0)'
                    }}
                  >
                    <div className="card-content">
                      <div className="card-body">
                        <div className="media d-flex">
                          <div className="media-body text-left">
                            <h4 className="text-success mb-1">Regimento Interno</h4>
                            <p className="card-subtitle">Normas e procedimentos internos</p>
                          </div>
                          <div className="align-self-center">
                            <i className="bi bi-journal-text text-success"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-sm-6 col-12">
                  <div 
                    className="card document-card dropbox h-100" 
                    onClick={(e) => {
                      e.preventDefault();
                      // Força execução imediata para manter contexto de user gesture no Safari
                      setTimeout(() => handleCardClick('https://www.dropbox.com/scl/fo/yjmqzaasm4qqaj9w95irh/AATHe3lPo533bC7iZ17AEIo?rlkey=gacnuyd2yhkdzs42kd91i3lco&st=dtmj5y6f&dl=0'), 0);
                    }}
                    role="button"
                    tabIndex={0}
                    aria-label="Acessar Dropbox - Repositório de arquivos"
                    style={{ 
                      cursor: 'pointer',
                      WebkitTapHighlightColor: 'rgba(0,0,0,0)'
                    }}
                  >
                    <div className="card-content">
                      <div className="card-body">
                        <div className="media d-flex">
                          <div className="media-body text-left">
                            <h4 className="text-warning mb-1">Dropbox</h4>
                            <p className="card-subtitle">Acesso ao repositório de arquivos</p>
                          </div>
                          <div className="align-self-center">
                            <i className="bi bi-box-arrow-up-right text-warning"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DocumentsPage;
